import { Navigate } from 'react-router-dom'

import { useAppStore } from '@runtime/core/store/appStore'
import { isAdminUserRole } from '@runtime/core/user/userRole'

export default function StudioHomeRedirect() {
  const authToken = useAppStore(state => state.authToken)
  const user = useAppStore(state => state.user)

  if (authToken && !user) {
    return null
  }

  return <Navigate to={isAdminUserRole(user?.role) ? '/' : '/login'} replace />
}
